function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C18.6268 24 24 18.6268 24 12C24 5.37321 18.6268 -4.69741e-07 12 -1.04907e-06C5.37322 -1.62841e-06 1.62841e-06 5.37321 1.04907e-06 12C4.69741e-07 18.6268 5.37321 24 12 24ZM11.1429 6.21428C11.1429 6.09643 11.2393 6 11.3571 6L12.6429 6C12.7607 6 12.8571 6.09643 12.8571 6.21428L12.8571 13.5C12.8571 13.6179 12.7607 13.7143 12.6429 13.7143L11.3571 13.7143C11.2393 13.7143 11.1429 13.6179 11.1429 13.5L11.1429 6.21428ZM12 15.4286C12.3364 15.4354 12.6568 15.5739 12.8923 15.8143C13.1278 16.0547 13.2597 16.3778 13.2597 16.7143C13.2597 17.0508 13.1278 17.3739 12.8923 17.6143C12.6568 17.8547 12.3364 17.9931 12 18C11.6636 17.9931 11.3432 17.8547 11.1077 17.6143C10.8722 17.3739 10.7403 17.0508 10.7403 16.7143C10.7403 16.3778 10.8722 16.0547 11.1077 15.8143C11.3432 15.5739 11.6636 15.4354 12 15.4286Z",
  fill: "var(--k-fg-f3bb1c)"
});

function SvgCircleWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWarning);
export default __webpack_public_path__ + "static/media/circle-warning.27f7345e.svg";
export { ForwardRef as ReactComponent };